import {App, initializeApp} from '@deviceinsight/ng-ui-scale-lib';
import {createRoot} from 'react-dom/client';
import {Ux4iotContextProvider} from 'ux4iot-react';
import {initReactI18next} from 'react-i18next';
import {ux4iotGrantRequestFunction} from '@deviceinsight/ng-ui-scale-lib/api';
import i18n from 'i18next';

import RafiCustomUiConfig from './RafiCustomUiConfig';
import {getRequiredEnv} from './utils/env';
import './setupDayjs';

import '@deviceinsight/ng-ui-scale-lib/dist/style.css';
import './loginPageStyles.less';
import './assets/styles.less';
import './assets/styles.scss';

if (!i18n.isInitialized) {
	await i18n.use(initReactI18next).init({
		fallbackLng: 'en',
		debug: false,
		react: {
			useSuspense: false
		}
	});
}

await initializeApp();

const customConfig = new RafiCustomUiConfig();
await customConfig.go();

const mountPoint = document.getElementById('app');
if (!mountPoint) {
	throw new Error('Could not find element with ID "app" in DOM');
}

createRoot(mountPoint).render(
	<Ux4iotContextProvider
		options={
			import.meta.env.DEV
				? {
						adminConnectionString: getRequiredEnv('REACT_APP_UX4IOT_CONNECTION_STRING')
				  }
				: {
						grantRequestFunction: ux4iotGrantRequestFunction,
						ux4iotURL: getRequiredEnv('REACT_APP_UX4IOT_URL')
				  }
		}>
		<App />
	</Ux4iotContextProvider>
);
